import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { ICustomField } from "@/models/custom-field.entity";
import customFieldService from "@/services/mrfiktiv/services/customFieldService";
import { MrfiktivCustomFieldControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const CustomFieldPageDataProvider = new (class extends AbstractPageDataProvider<
  ICustomField,
  MrfiktivCustomFieldControllerGetParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivCustomFieldControllerGetParamsGen): Promise<IPageViewModel<ICustomField>> {
    const res = await customFieldService.get({ ...query });

    const meta = res.meta;
    const data = (res.data || []) as ICustomField[];

    return { meta, data };
  }
})();
